export default "__VITE_ASSET__2JfqTZeX__"